import { render, staticRenderFns } from "./PendingRequestsControl.vue?vue&type=template&id=de7f76a6&"
import script from "./PendingRequestsControl.vue?vue&type=script&lang=js&"
export * from "./PendingRequestsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports